module.exports = __webpack_public_path__ + "img/2015041.02285249.svg";